(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Navbar visibility controller - updates shop button and cart icon based on current path
  class NavbarVisibilityController {
    constructor() {
      this.isProductPage = false;
      this.shopButton = null;
      this.cartIcon = null;
      this.init();
    }

    init() {
      // Wait for DOM to be ready
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.setup());
      } else {
        this.setup();
      }
    }

    setup() {
      this.shopButton = document.querySelector('.mobile-shop-button');
      this.cartIcon = document.querySelector('.header__icon--cart');
      
      // Update on initial load
      this.updateNavbarVisibility();
      
      // Listen for URL changes (back/forward navigation)
      window.addEventListener('popstate', () => {
        this.updateNavbarVisibility();
      });
      
      // Listen for pageshow event (handles browser navigation, including back/forward cache)
      window.addEventListener('pageshow', (event) => {
        // event.persisted is true when page is loaded from cache
        if (event.persisted) {
          this.updateNavbarVisibility();
        }
      });
      
      // Listen for pushState/replaceState (AJAX navigation)
      this.interceptHistoryMethods();
      
      // Listen for link clicks that might navigate
      this.interceptLinkClicks();
      
      // Also check periodically in case of other navigation methods
      // This is a fallback for any navigation that doesn't trigger popstate
      let lastPath = window.location.pathname;
      setInterval(() => {
        if (window.location.pathname !== lastPath) {
          lastPath = window.location.pathname;
          this.updateNavbarVisibility();
        }
      }, 100);
    }

    updateNavbarVisibility() {
      const currentPath = window.location.pathname;
      this.isProductPage = currentPath === '/products/gpath-pin';
      
      // Re-find elements in case they were replaced during AJAX navigation
      if (!this.shopButton || !document.contains(this.shopButton)) {
        this.shopButton = document.querySelector('.mobile-shop-button');
      }
      if (!this.cartIcon || !document.contains(this.cartIcon)) {
        this.cartIcon = document.querySelector('.header__icon--cart');
      }
      
      // Use setProperty with important flag to override !important CSS rules
      if (this.shopButton) {
        if (this.isProductPage) {
          this.shopButton.style.setProperty('display', 'none', 'important');
        } else {
          this.shopButton.style.setProperty('display', 'inline-flex', 'important');
        }
      }
      
      if (this.cartIcon) {
        if (this.isProductPage) {
          this.cartIcon.style.setProperty('display', 'flex', 'important');
        } else {
          this.cartIcon.style.setProperty('display', 'none', 'important');
        }
      }
    }

    interceptHistoryMethods() {
      // Intercept pushState
      const originalPushState = history.pushState;
      history.pushState = (...args) => {
        originalPushState.apply(history, args);
        setTimeout(() => this.updateNavbarVisibility(), 0);
      };
      
      // Intercept replaceState
      const originalReplaceState = history.replaceState;
      history.replaceState = (...args) => {
        originalReplaceState.apply(history, args);
        setTimeout(() => this.updateNavbarVisibility(), 0);
      };
    }

    interceptLinkClicks() {
      // Listen for clicks on links that navigate to product page
      document.addEventListener('click', (e) => {
        const link = e.target.closest('a');
        if (link && link.href) {
          try {
            const url = new URL(link.href, window.location.origin);
            // If clicking a link that goes to the product page, update navbar
            if (url.pathname === '/products/gpath-pin') {
              // Small delay to ensure navigation happens
              setTimeout(() => this.updateNavbarVisibility(), 50);
            } else if (url.pathname !== window.location.pathname) {
              // If navigating away from product page
              setTimeout(() => this.updateNavbarVisibility(), 50);
            }
          } catch (err) {
            // Invalid URL, ignore
          }
        }
      }, true);
    }
  }

  // Initialize navbar visibility controller
  new NavbarVisibilityController();

  } catch(e) { console.error(e); }
})();
})();
